import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const EditTemplateV2Lazy = React.lazy(
	() => import(/* webpackChunkName: 'EditTemplateV2' */ './components')
);

// eslint-disable-next-line no-unused-vars
export default (_store) => {
	return {
		path: 'report-configure/report-templates/:campusId/edit/:templateId',
		element: (
			<AsyncLoading
				component={
					<EditTemplateV2Lazy permission="CanConfigureProgressReportsTemplates" />
				}
			/>
		),
		children: [],
	};
};
